import React, { useRef, useState, useEffect } from "react";
import { Button, Card, CardBody } from "reactstrap";
import html2canvas from "html2canvas";
import burger from "../../../../assets/qrcode/natapola-removebg.png";
import sebs from "../../../../assets/sebs/sebs.png";
import { QRCodeCanvas } from "qrcode.react";
// import QRCodeGenerator from "../Qrgenerator";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import FoodMenuService from "../../../../Services/QRCodeServices/CustomerService/FoodMenuService";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import FoodSection from "./foodSection/FoodSection";
import "./PrintFlyer.css";
// import foodimg from "./foodimg.jpg"
// import foodimg from "./foodo.png"
import foodimg from "./item.png";
import OrgLogo from "./orgLogo.jpeg";

// import MainImgBg from "./assets/bkg-with-red-stripe.jpg";
// import scanText from "./assets/txt-view-our-menu.png";
import NewViewMenu from "./newviewmenus.PNG"
// import NewViewMenu from  "./newviewmenu.png"

import delievry from "./free home delivery.jpeg";
import services from "./our special.jpeg";
import viewmenu from "./view our menu.jpeg";
import sebsLogo from "./SEBSLOGO.jpeg";
import hrline from "./hr line.jpeg";
import logoRedBG from "./logoredbg.PNG";

const PrintFlyer = () => {
  // const {id} = useParams();
  // console.log("🚀 ~ id:", id)
  const proxyUrl = `https://api.qrmenu.asia/api/proxy`;

  const navigate = useNavigate();
  const modalRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = user?.organizationInfo?.id || ""; // Null if user or organizationInfo is not available
  const orgCode = user?.organizationInfo?.orgCode || data?.orgCode; // If orgCode exists, use it; otherwise, use id
  const organizationInfo = user?.organizationInfo || {}; // If organizationInfo exists, use it; otherwise, use an empty object
  // const [orgLogo, setOrgLogo] = useState('')
  let orgLogo;

  const [data, setData] = useState([]);
  const [specialItems, setSpecialItems] = useState([]);

  const foodSectionDataStatic = [
    {
      FoodImg: foodimg,
      FoodTitle: "SAMAY BAJI SET",
      FoodDescription:
        "Baji, Bhatmas, Lava, Palu, Aloo, Bodi Achar, Egg, Choila(Buff or Chicken), & Complimentary Aaila in salicha",
      FoodPrice: 450,
    },
    {
      FoodImg: foodimg,
      FoodTitle: "Your Fav item",
      FoodDescription:
        "We can set item as favourite from menu items so that it will be shown here",
      FoodPrice: 100,
    },
    {
      FoodImg: foodimg,
      FoodTitle: "Your Fav item",
      FoodDescription:
        "We can set item as favourite from menu items so that it will be shown here",
      FoodPrice: 100,
    },
    {
      FoodImg: foodimg,
      FoodTitle: "Your Fav item",
      FoodDescription:
        "We can set item as favourite from menu items so that it will be shown here",
      FoodPrice: 100,
    },
  ];

  const fetchDetail = async () => {
    try {
      const [response, res] = await Promise.all([
        OrganizationService.detail(orgId),
        FoodMenuService.getSpecialItems({ pageNumber: 1, pageSize: 10 }),
      ]);

      setData(response);
      if (res?.length > 0) {
        const temp = res.slice(0, 4).map((item) => ({
          FoodImg: item.cloudR2ImagePath.getCDNUrl(),
          FoodTitle: item.title || "No Title",
          FoodDescription: item.description || "No Description Available",
          FoodPrice: item.price || 0,
        }));

        setSpecialItems(temp);
      } else {
        //statsic data
        setSpecialItems(foodSectionDataStatic);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  console.log(data);
  console.log("🚀 ~ orgCode:", data.orgCode);

  const url = `${window.location.origin}/${orgCode}?source=qr-menu`;

  const canvasConfig = {
    scale: 3,
    //useCORS: true,
    //allowTaint: true,
    backgroundColor: "#f0f7ff",
    logging: false,
    //proxy: data?.cloudR2ImagePath?.getCDNUrl()
    proxy: proxyUrl,
    // width: 200,
    // height: 200,
    imageSettings: {
      crossOrigin: "Anonymous",
      src: OrgLogo,
    },
  };

  const downloadAsImage = async () => {
    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, canvasConfig);

      canvas.toBlob(
        (blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${data?.name || "qr-code"}-menu.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
        "image/jpeg",
        1.0
      );
    } catch (error) {
      console.error("Error generating image:", error);
    }

    console.log("Download img clicked");
  };

  const handlePrint = async () => {
    try {
      const modalElement = modalRef.current;
      const canvas = await html2canvas(modalElement, canvasConfig);
      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        alert("Please allow popups to print");
        return;
      }

      printWindow.document.write(`
                <html>
                  <head>
                    <title>Print QR Code</title>
                    <style>
                      @media print {

                        body {
                          margin: 0;
                          padding: 0;
                        }

                        img {
                                width: 24in;  
                                height: 36in; 
                                object-fit: contain;
                                display: block !important;
                        }

                      }
                    </style>
                  </head>
                  <body>
                 
                    <img src="${canvas.toDataURL("image/jpeg", 1.0)}" />
                   
                    <script>
                      window.onload = function() {
                        window.print();
                        window.onafterprint = function() {
                          window.close();
                        }
                      }
                    </script>
                  </body>
                </html>
            `);
      printWindow.document.close();
    } catch (error) {
      console.error("Error printing:", error);
    }

  

    console.log("handle print clicked");
  };

  const convertImageToBase64 = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  console.log(specialItems);

  return (
        <div className="page-content">
          <div className="container-fluid">
            <BreadCrumb title="QR Menu" pageTitle="Dashboard" />
          </div>
          <div className="qr-modal-container d-flex flex-column justify-content-center align-items-center">

            <div className="d-print-none d-flex justify-content-end align-items-center w-100">
              <Button
                className="action-btn"
                color="danger"
                onClick={() => navigate(`/org-dashboard`)}
              >Back</Button>
              <Button className="action-btn" color="success" onClick={downloadAsImage}>
                Download QR
              </Button>
              <Button className="action-btn" color="primary" onClick={handlePrint}>
                Print QR
              </Button>
            </div>

            <div 
              className="model-container-one-flyer  d-print  px-3 "
              ref={modalRef}
            >
              <Row className="h-100">

              {/* md={5}  in this col  */}
                <Col className="h-100 d-flex flex-column ribbon text-center p-0" >

                  <div className="rounded-0 logoSection  " >

                    {/* <img
                      className="img-contain "
                      src={data?.cloudR2ImagePath?.getCDNUrl()}
                      alt={"org logo"}
                      height={140}

                     
                      style={{borderRadius: "30rem"}}
                    /> */}

                    <div
                      style={{
                        width: "140px",
                        height: "140px",
                        borderRadius: "30rem",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f9f9f9" // optional placeholder bg
                      }}
                    >
                      <img
                        src={data?.cloudR2ImagePath?.getCDNUrl()}
                        alt="org logo"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain" // or "cover" depending on your need
                        }}
                      />
                    </div>

                    <div className="text-center mt-2">
                      <div className="address">{data.address1}</div>
                      <div className="phonenum">{data.contactNo}</div>
                    </div>

                  </div>

                  {/* <hr/> */}
                  <div>
                    <img
                      src={hrline}
                      alt="org logo"
                      height={15}
                      className=" w-100 text-center object-fit-cover "
                    />
                  </div>

                  <div
                    className="  pt-4 pb-3 "
                  >
                    <div className="pb-2">
                      <img src={NewViewMenu} alt="org logo" height={100} width={150} />
                    </div>

                    <div  style={{border: "3px solid white", borderRadius: "5px",display: "inline-block", background: "white"}}>
                  
                        <QRCodeCanvas
                          value={url}
                          size={150}
                          fgColor="#000000"
                            bgColor="#ffffff"
                          // fgColor="#f0f7ff"
                          // bgColor="#E91E24"
                        />
                   
                    </div>
                  </div>

                  {/* <hr/> */}
                  <div>
                    <img
                      src={hrline}
                      alt="line logo"
                      height={15}
                      className=" w-100 text-center  "
                    />
                  </div>

    <div class="ourBrand  mt-3">

                  <img
                    src={sebsLogo}
                    alt="sebs logo"
                    height="100px"
                    className="object-fit-contain"
                  />

                  <div className="tel " style={{marginTop: "-10.5px"}}>
                    <i
                      className="ri-phone-line"
                    ></i>

                    <span >
                      {" "}
                      9843723855
                    </span>
                  </div>
                  </div>

                </Col>

                {/* food*/}
                <Col className="red rounded my-3 foodCol position-relative">

                  <Row className=" text-center mt-4">
                    <div className=" ">
                      <img
                        src={services}
                        alt="services logo"
                        height={50}
                        width={250}
                        className="  "
                      />
                    </div>
                  </Row>

                  {/* foodSectionDataStatic text-center mt-3 specialItems */}
                  <Row className="gy-3 mt-1 pe-3">
                    <FoodSection data={specialItems} />
                  </Row>

                  {(!organizationInfo.ispaid) ?
                    <>
                      <Row className="text-center" style={{ position: "absolute", bottom: "1rem", paddingLeft: "1rem" }}>
                        <Col className="">
                          Free QR Menu for Any Organization.<br />
                          Signup for Free QR Menu at <br />
                          https://qrmenu.asia
                        </Col>
                      </Row>
                    </> : ""
                  }
                </Col>
              </Row>
            </div>

          </div>
        </div>


  );
};

export default PrintFlyer;
